import { render } from "./GuardianListTable.vue?vue&type=template&id=dc4baa72&scoped=true&ts=true"
import script from "./GuardianListTable.vue?vue&type=script&lang=ts"
export * from "./GuardianListTable.vue?vue&type=script&lang=ts"

import "./GuardianListTable.vue?vue&type=style&index=0&id=dc4baa72&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4baa72"]])

export default __exports__